export default function WhyUKBased() {
  const benefits = [
    {
      icon: 'ri-money-pound-circle-line',
      title: 'Clear Pricing in GBP',
      description: 'Transparent costs with no hidden fees or currency conversion surprises'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'UK Consumer Protections',
      description: 'ATOL protection and familiar UK travel regulations for your peace of mind'
    },
    {
      icon: 'ri-message-3-line',
      title: 'Cultural &amp; Communication Clarity',
      description: 'UK-based advisors who understand your needs and speak your language'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Reliable After-Sales Support',
      description: 'Accessible before, during, and after your move with 24/7 UK support'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-[#C9A961]/10 text-[#C9A961] text-sm font-semibold rounded-full mb-4">
            Trusted by UK Residents
          </div>
          <h2 className="text-4xl font-bold text-[#1A1F2E] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Why UK-Based Travel Advisors Are Trusted
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            UK residents consistently prefer UK-based travel advisors for relocation journeys. Here's why we're your trusted partner.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#C9A961]/10 rounded-2xl mb-6">
                <i className={`${benefit.icon} text-3xl text-[#C9A961]`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A1F2E] mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-[#1A1F2E] to-[#2A3F5E] rounded-2xl p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            At Alwaz Travels, we remain accessible before, during, and after your move
          </h3>
          <p className="text-gray-200 text-lg mb-8 max-w-3xl mx-auto">
            Our commitment doesn't end when you board the plane. We're here to support your entire relocation journey.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-[#C9A961] text-white rounded-lg hover:bg-[#B89851] transition-colors whitespace-nowrap cursor-pointer font-semibold"
            >
              Start Your Relocation
            </a>
            <a
              href="https://wa.me/447362505895"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-lg hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer font-semibold"
            >
              <i className="ri-whatsapp-line"></i>
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
